import React from "react";
import { FacebookIcon, YouTubeIcon, LinkedinIcon } from "dab-component-lib";
import { withRouter } from "react-router";
import { GridContainerStyle } from "../../../utils/style-utils";
import {
  FooterStyle,
  FooterColStyle,
  FooterRowStyle,
  SocialContainerStyle,
  SocialLinkStyle,
  LinkStyle,
} from "./style";

const Footer = ({ history }) => {
  return (
    <FooterStyle>
      <GridContainerStyle>
        <FooterRowStyle center>
          <FooterColStyle>
            <LinkStyle onClick={() => history.push("/policy")}>
              Privacy Policy
            </LinkStyle>
            <LinkStyle onClick={() => history.push("/cookies")}>
              Cookies
            </LinkStyle>
            <p>
              Dab Pumps Spa © Via Marco Polo, 14 Mestrino Padova - Italy Tel.
              +39.049.5125000 Fax +39.049.5125950
              <br />
              P.I. 03675230282 - R.E.A. Padova N. 328200- Cap. Soc. Euro
              €10.000.000 i.v.
              <br />
            </p>
          </FooterColStyle>
          <FooterColStyle>
            <SocialContainerStyle>
              <SocialLinkStyle
                href="https://www.dabpumps.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={require("../../../images/dabcorporate.svg")}
                  width="32"
                  height="32"
                  alt="DAB"
                />
              </SocialLinkStyle>
              <SocialLinkStyle
                href="https://www.facebook.com/DABPumps"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FacebookIcon size={32} />
              </SocialLinkStyle>
              <SocialLinkStyle
                href="https://www.youtube.com/user/dwtgroup"
                target="_blank"
                rel="noopener noreferrer"
              >
                <YouTubeIcon size={32} />
              </SocialLinkStyle>
              <SocialLinkStyle
                href="https://www.linkedin.com/company/dab-pumps"
                target="_blank"
                rel="noopener noreferrer"
              >
                <LinkedinIcon size={32} />
              </SocialLinkStyle>
            </SocialContainerStyle>
          </FooterColStyle>
        </FooterRowStyle>
      </GridContainerStyle>
    </FooterStyle>
  );
};

export default withRouter(Footer);



// WEBPACK FOOTER //
// ./src/components/common/footer/index.js